import type { ClientAPI } from './generated/client-api-types'
import { initAPI } from './init-http'

export const httpAPI = initAPI<ClientAPI>({
  projection: {
    contentCategories: true,
    uploadedFiles: true,
    publisherSites: true,
    connectedSites: true,
    sitePages: true,
    attachableVideos: true,
    viadsFlowStatusForPublisher: false,
    publisherViadsFlowStatus: true,
    nextFlowFeedItem: false,
  },
  command: {
    addContentCategory: false,
    deleteContentCategory: false,
    renameContentCategory: false,
    activateViadsFlowForPublisher: false,
    deactivateViadsFlowForPublisher: false,
    deleteUploadedFile: true,
    publishUploadedFile: true,
    connectPublisherSite: true,
    registerSitePage: true,
    attachSitePageVideo: true,
  },
})
